import { createReducer } from 'redux-act'

import { Styleboard } from 'features/Styleboard/types'

import { PublicProfileState, Notification, PublicProfilePageResponse } from '../types'
import actions from './actions'
import { initialState } from './initialState'

const filterUniqueValues = <T>(array: Array<T>, property: string): Array<T> => {
  return Array.from(new Map(array.map((item) => [item[property], item])).values())
}

const addNotification = (state, notification: Notification): PublicProfileState => {
  return {
    ...state,
    notification,
  }
}

const resetNotifications = (state): PublicProfileState => ({
  ...state,
  notification: null,
})

const fetchPublicProfilePageStart = (state): PublicProfileState => ({
  ...state,
  isPublicProfilePageLoading: true,
})

const fetchPublicProfilePageSuccess = (
  state,
  payload: PublicProfilePageResponse,
): PublicProfileState => {
  return {
    ...state,
    profile: {
      ...payload.user,
    },
    publicStyleboards: {
      ...payload,
      styleboards: filterUniqueValues<Styleboard>(
        [
          ...(payload.mergeDeep && state.publicStyleboards
            ? state.publicStyleboards.styleboards
            : []),
          ...payload.styleboards,
        ],
        'id',
      ),
    },
    isPublicProfilePageLoading: false,
    isPublicProfilePageLoaded: true,
  }
}

const fetchPublicProfilePageFail = (state): PublicProfileState => {
  return {
    ...state,
    isPublicProfilePageLoading: false,
    isPublicProfilePageLoaded: true,
    isPublicProfilePageLoadingFailed: true,
  }
}

const fetchPublicProfilePageSuccessNoContent = (state): PublicProfileState => {
  return {
    ...state,
    isPublicProfilePageLoading: false,
    isPublicProfilePageLoaded: true,
    publicStyleboards: {},
  }
}

const reducer = createReducer((on) => {
  on(actions.fetchPublicProfilePageStart, fetchPublicProfilePageStart)
  on(actions.fetchPublicProfilePageSuccess, fetchPublicProfilePageSuccess)
  on(actions.fetchPublicProfilePageFail, fetchPublicProfilePageFail)
  on(actions.addNotification, addNotification)
  on(actions.resetNotifications, resetNotifications)
  on(actions.fetchPublicProfilePageSuccessNoContent, fetchPublicProfilePageSuccessNoContent)
}, initialState)

export default reducer
